import React, { useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { Popover } from '@mui/material'

import { toast } from 'react-toastify'
import iconGuardar from '../img/iconGuardar.svg'
import iconVistaPrevia from '../img/iconVistaPrevia.svg'
import iconCompartir from '../img/iconCompartir.svg'
import iconCompartirFlecha from '../img/iconCompartirFlecha.svg'

import { DialogAnular } from '../anular/DialogAnular'

import VistaPrevia from '../vistaPreviaPdf/VistaPrevia'
import { useBuy } from '../../../hooks/useBuy'

import { emit } from "../../../utils/eventBus";
import { Buy } from '../../../models/buy'

export const FormActions = ({ checkInitialData, setForm, dataForm, setPaymentsModal, setPaymentsModalList, setInvoceModalList, setOpenExtendedMode, loadIniBudget }) => {

    const { initSaveBuy } = useBuy()
    const { id, pays = [], estado, pay_for_items = false } = dataForm

    const [openPreview, setopenPreview] = useState(false)
    const [openAnular, setOpenAnular] = useState(false)

    const handleSave = async (e) => {
        e.preventDefault()

        if (parseInt(dataForm?.id_moneda) === 4 && parseFloat(dataForm?.valor_tipo_cambio) === 0) {
            toast.warning('Falta ingresar tipo de cambio')
            return false
        }

        if (parseFloat(id) > 0) {
            // initUpdateBuy(dataForm, loadIniBudget)
            await Buy.update(dataForm)
            emit("flows_updated");

        } else {

            await initSaveBuy(dataForm, loadIniBudget)
            emit("flows_updated");

            setOpenExtendedMode(false)
        }

        /*  emit("flows_updated"); */

    }

    const handlePreview = () => {
        setopenPreview(true)
    }

    const handleShare = (event) => {
        setAnchorEl(event.currentTarget)
    }

    // const handleValidate = () => {
    //     toast.info('SOON!');
    // }

    // const handleReject = () => {
    //     toast.info('SOON!');
    // }

    const handleVerPagos = () => {
        setPaymentsModalList(true);
    }

    const handleVerFacturas = () => {
        setInvoceModalList(true);
    }

    const [anchorEl, setAnchorEl] = useState(null)

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl);
    const idx = open ? 'simple-popover' : undefined;


    // const shareEmail = () => {
    //     document.getElementById('link-open-email').click()
    // }

    // const shareWhatsapp = () => {
    //     const textPpto = `( ${numero} ) ${referencia}`
    //     const url = document.URL
    //     const text = `Hola, te comparto la orden de compra ${textPpto}: ${url}`
    //     window.open(`https://wa.me/?text=${text}`)
    // }

    const sharePdf = () => {
        handlePreview()
    }

    // const copyUrl = () => {
    //     const url = document.URL
    //     navigator.clipboard.writeText(url)
    //     toast.info('copiado!')
    // }

    return (
        <>

            {openPreview &&
                <VistaPrevia
                    open={openPreview}
                    setOpen={setopenPreview}
                    dataPreview={dataForm}
                />
            }

            {openAnular &&
                <DialogAnular
                    checkInitialData={checkInitialData}
                    compraId={id}
                    open={openAnular}
                    setOpen={setOpenAnular}
                    dataPreview={dataForm}
                    setForm={setForm}
                />
            }

            <div className='row'>
                <div className="col-8 d-flex">

                    {/* {(estado !== 'anulada' && estado !== 'pagada') && */}
                    {(estado !== 'anulada') &&
                        <button className='btn p-btn-secondary d-flex align-items-center' onClick={handleSave}>
                            <img src={iconGuardar} alt='guardar' />
                            <span>Guardar</span>
                        </button>
                    }

                    {(id > 0 && id !== null && estado !== 'anulada') &&
                        <>
                            <button className='btn p-btn-secondary d-flex align-items-center' onClick={handlePreview}>
                                <img src={iconVistaPrevia} alt='vista previa' />
                                <span>Vista previa</span>
                            </button>

                            <button
                                className='btn p-btn-secondary d-flex align-items-center'
                                onClick={handleShare}
                                disabled={dataForm.estado_validacion === 'por validar'}
                            >
                                <img src={iconCompartir} alt='compartir' />
                                <span style={{ marginLeft: '8px' }}>Compartir</span>
                                <img style={{ marginLeft: '5px' }} src={iconCompartirFlecha} alt='flecha' />
                            </button>

                            {(id > 0 && estado !== 'pagada' && estado !== 'anulada') &&
                                <button
                                    className='btn p-btn-secondary d-flex align-items-center'
                                    onClick={() => setOpenAnular(true)}>
                                    <i className="bi bi-x-circle"></i>
                                    <span style={{ marginLeft: '8px' }}>Anular</span>
                                </button>
                            }

                            {/* <button className='btn p-btn-secondary d-flex align-items-center' onClick={handleValidate}>
                                <span style={{ marginLeft: '8px', color: '#5CBF66' }}>Validar</span>
                            </button>

                            <button className='btn p-btn-secondary d-flex align-items-center' onClick={handleReject}>
                                <span style={{ marginLeft: '8px', color: '#ED4E4E' }}>Rechazar</span>
                            </button> */}

                        </>
                    }

                </div>

                <div className="col-4 d-flex justify-content-end align-items-center">

                    {(pays && pays.length > 0 &&
                        <div className='flex flex-col text-end'>
                            <Link to='#' className='link pagos' onClick={handleVerPagos}>Ver pagos</Link>
                            {pay_for_items && <span>Pagos por ítems</span>}
                        </div>
                    )}

                    {((dataForm.nro_doc_justificacion !== null && dataForm.nro_doc_justificacion !== '' && dataForm.estado !== null) &&
                        <Link to='#' className='link facturas' onClick={handleVerFacturas}>Ver Doc.</Link>)
                    }

                </div>



            </div>


            <Popover
                className='p-popover-share'
                id={idx}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div className='options'>

                    {/* <a
                        style={{ display: 'none' }}
                        id="link-open-email"
                        href={`mailto:${contacto_email}?subject=${`orden de compra #${numero} / ${referencia}`}&body=${`Hola, te envio la orden de compra #${numero} / ${referencia} ( ${document.URL} )`}`}
                    >
                        soy envisible!
                    </a> */}

                    {/* <a href="#" onClick={shareEmail}>
                        <i className="bi bi-envelope-check"></i>
                        <span>Email</span>
                    </a>

                    <a href="#" onClick={shareWhatsapp}>
                        <i className="bi bi-whatsapp"></i>
                        <span>WhatsApp</span>
                    </a> */}

                    {/* <a href="#" onClick={sharePdf}>
                        <i className="bi bi-filetype-pdf"></i>
                        <span>Pdf</span>
                    </a>

                    <a href="#" onClick={copyUrl}>
                        <i className="bi bi-link-45deg"></i>
                        <span>Copiar enlace</span>
                    </a> */}

                    {/* <button onClick={shareEmail}>
                        <i className="bi bi-envelope-check"></i>
                        <span>Email</span>
                    </button> */}

                    {/* <button onClick={shareWhatsapp}>
                        <i className="bi bi-whatsapp"></i>
                        <span>WhatsApp</span>
                    </button> */}

                    <button onClick={sharePdf}>
                        <i className="bi bi-filetype-pdf"></i>
                        <span>Pdf</span>
                    </button>

                    {/* <button onClick={shareWhatsapp}>
                        <i className="bi bi-link-45deg"></i>
                        <span>Copiar enlace</span>
                    </button> */}

                </div>
            </Popover>

        </>

    )
}